import { Injectable } from '@angular/core';

import * as Sentry from '@sentry/angular';

import { CaptureContext } from '@sentry/types';
import {
  ExclusiveEventHintOrCaptureContext,
} from '@sentry/core/build/types-ts3.8/utils/prepareEvent';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  constructor() {
  }

  setUser(user: Sentry.User | null) {
    Sentry.setUser(user);
  }

  captureMessage(event: string, context?: CaptureContext) {
    Sentry.captureMessage(event, context);
  }

  captureException(exception: any, hint?: ExclusiveEventHintOrCaptureContext) {
    Sentry.captureException(exception);
  }
}
